import React from 'react'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { useCmsBlock } from 'lib/core/hooks'
import { Wrapper } from './styled'

export const Reviews = () => {
  const blockId = CMS_BLOCK.PPL_REVIEWS
  const columnsContent = useCmsBlock({
    id: blockId
  })

  if (!columnsContent.content) return null
  return (
    <Wrapper
      dangerouslySetInnerHTML={{
        __html: columnsContent.content
      }}
    />
  )
}
